<template>
  <div class="message-div">
    <Appbar title="公告">
      <!-- <span text slot="left"></span> -->
    </Appbar>

    <v-list-item style="flex: none;">
      <v-list-item-avatar>
        <v-img src="@/static/pages/message/notice.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ notice.noticeTitle }}</v-list-item-title>
        <v-list-item-subtitle>{{ notice.creationTime }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <div class="message-content" id="editor-html" v-html="notice.noticeFuText || notice.noticeText"></div>
  </div>
</template>

<script>
import Appbar from '@c/layout/Appbar'
export default {
  components: {
    Appbar
  },
  data() {
    return {
      notice: {}
    }
  },
  computed: {
    _cdn() {
      return this.$store.getters['app/cdn']
    }
  },
  methods: {
    getDetail() {
      let query = this.$route.query

      // if(this.noticeList&&this.noticeList.length){
      //     this.notice=this.noticeList.find(item=>item.noticeId==query.msgId)
      // }else{
      this.$store.dispatch('message/getNoticeByPage', { page: 1, limit: query.index == 0 ? 20 : query.index * 1 + 1 }).then(res => {
        // td p{text-align:center}
        let htmlObj = res.data.list.find(item => item.noticeId == query.msgId)
        // htmlObj.noticeFuText =
        //   htmlObj.noticeFuText +
        //   `<style>
        //         .message-div span{white-space:normal !important;text-wrap:wrap !important;}
        //         table {border: 1px solid #ccc;border-collapse: collapse;}
        //         th,td {border: 1px solid #ccc;padding:3px}p{margin-bottom:0 !important;}
        //         table a{text-decoration: underline;padding: 5px 0;display: inline-block;}
        //         code{padding:0 !important;}

        //         </style>`
        // console.error(htmlObj, 'htmlObj')
        this.notice = htmlObj
        this.$nextTick(() => {
          window.uParse('#editor-html', {
            rootPath: this._cdn + '/pc/common/Ueditor/third-party'
          })
        })
      })
      // }
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="scss">
.message-div {
  background-color: #fff;
  max-height: 100%;
  display: flex;
  flex-direction: column;

  .message-content {
    padding: 20px 10px;
    overflow: auto;
  }

  .v-divider {
    width: 100%;
  }
}
</style>
